import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';

import appActions from '../../actions/actions';
import multipleAccountsActions from '../../actions/multipleAccounts';
import confirmBrandActions from '../../actions/confirmBrand';
import ConfirmBrand from '../ConfirmBrand/ConfirmBrand';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', ''),
        emailAddress: get(state, 'app.userEmailAddress', ''),
        siteName: state.system.siteName,
        translations: state.app.translations,
        serviceError: get(state, 'multipleAccounts.serviceError', ''),
        userType: get(state, 'app.userType', ''),
        isConsolidationRequired: get(state, 'app.isConsolidationRequired', false),
        primarySite: get(state, 'confirmBrand.primarySite', {}),
        primarySiteMap: get(state, 'brandDetermination.primarySiteMap', {}),
        integratedBrandsPrimarySiteList: get(state, 'app.integratedBrandsPrimarySiteList', []),
        bankingCountryCode: get(state, 'brandDetermination.bankingCountryCode', ''),
        currency: get(state, 'brandDetermination.currency', ''),
        dyff: get(state, 'app.dyff', ''),
        dropDownCurrency: get(state, 'currency.currency',''),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        multipleAccountsActions: bindActionCreators(multipleAccountsActions, dispatch),
        confirmBrandActions: bindActionCreators(confirmBrandActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class ConfirmBrandContainer extends React.Component {
    constructor(props) {
        super(props);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.props.appActions.enableLoadOverLay(false);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.handleAccountSelection = this.handleAccountSelection.bind(this);
        this.handleBankingCountrySelection = this.handleBankingCountrySelection.bind(this);
        this.handleContinueToBasicInformation = this.handleContinueToBasicInformation.bind(this);
        this.getYesSelection = this.getYesButtonClickAction.bind(this);
        this.getNoSelection = this.getNoButtonClickAction.bind(this);
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Confirm Brand Page');
    }

    handleAlertDismiss() {
            this.props.confirmBrandActions.dismissAlertBox();
    }

    // For PPM Users
    handleAccountSelection = (event, primarySite) => {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});
        const confirmAccountDetails = {
            primarySite,
            userType: this.props.userType,
            isConsolidationRequired: this.props.isConsolidationRequired,
            /**
             * NOTE: the order of what currency states we check matters here
             * Case 1: user views brandDetermination page then this.props.currency is populated with the selected currency and we use that
             * Case 2: user navigated straight to the confirmBrand page then this.props.currency is empty, so we will need to use the selected currency in this.props.dropDownCurrency
             * Case 3: user ONLY has 1 currency (i.e. Australia) and both 1) and 2) states are empty, so we'll need to use primarySite.currencies[0] value
             * */
            currency: this.props.currency || this.props.dropDownCurrency || primarySite.currencies[0]
        }
        // add onboarding message service -> on success PPM_IDENTIFIED status along with site selected
        this.props.multipleAccountsActions.confirmAccount(confirmAccountDetails);
    }

    // For PPM users with Discontinued Brands
    handleBackToBrandDeterminationPage = (event) => {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Back'
        }, {});

        // NOTE: instead of going back to Discontinued Page we take them back to the Brand Determination page
        this.props.appActions.changeAppState('BRAND_DETERMINATION');
    }

    // For IPM Users and PPM Users in handling language-currency mismatch
    handleBankingCountrySelection = (event) => {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});
        this.props.appActions.changeAppState('BRAND_DETERMINATION');
    }

    // For IPM Users
    handleContinueToBasicInformation = (event) => {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});
        const {siteName, primarySite, currency} = this.props;

        if (siteName !== primarySite.name) {
            this.props.confirmBrandActions.redirectWithBrandSwitchParam(primarySite, currency);
        } else {
            // PM is already on the correct brand
            this.props.appActions.changeAppState('BASIC_INFORMATION');
        }
    }

    getYesButtonClickAction() {
        if (this.props.userType === 'PPM') {
            return this.handleAccountSelection;
        }
        return this.handleContinueToBasicInformation;
    }

    getNoButtonClickAction() {
        if (this.props.userType === 'PPM') {
            return this.handleBackToBrandDeterminationPage;
        }

        return this.handleBankingCountrySelection;
    }

    render() {
        return (
            <ConfirmBrand
                translations={this.props.translations}
                primarySite={this.props.primarySite}
                currency={this.props.currency}
                integratedBrandsPrimarySiteList={this.props.integratedBrandsPrimarySiteList}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                handleYesButtonClick={this.getYesButtonClickAction()}
                handleNoButtonClick={this.getNoButtonClickAction()}
                isPPM={this.props.userType === 'PPM'}
                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}
            />
        );
    }
}

ConfirmBrandContainer.propTypes = {
    publicUuid: PropTypes.string,
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
};

ConfirmBrandContainer.defaultProps = {
    publicUuid: '-1'
}
